/**
 * 请求缓存
 */
class RequestCache{
    constructor(){
        this.cache={};
    }
    initItem(key){
        return this.cache[key]={watchedNumber:0,isLoaded:false,isCache:true,createTime:new Date().getTime()};
    }
    setItem(key,value,config={}){
        const {cache}=this;
        let item=cache[key];
        if(!item){
            item=this.initItem(key)
        }
        item.isLoaded=true;
        item.value=value;
        if(config===true)config={};
        item.expiresCount=config.expiresCount||3;
        item.updateTime=new Date().getTime();
        item.expiresTime=item.updateTime+(config.expiresTime||10000);
        return item
    }
    getItem(key){
        let item=this.cache[key];
        if(!item){
            item=this.initItem(key)
        }
        item.watchedNumber++;
        if(item.watchedNumber>=item.expiresCount||item.expiresTime<=new Date().getTime()){
            item=this.initItem(key)
        }
        return item
    }
    assign(key,value){
        let item=this.cache[key];
        if(!item){
            item=this.initItem(key);
        }
        Object.assign(item.value,value);
    }
    isLoadedItem(key){
        return this.getItem(key).isLoaded
    }
}
export default new RequestCache();


